import { Card, CardContent, CardHeader, CardTitle } from "../../UI/card";
import { AnimatedDiv } from "../horizontalBarChart";
import Loader from "../../CommonComponent/Loader/Loader";
import { getColorClass } from './index'
import { useSelector } from "react-redux";
import InfoMark from "./infoMark";
import { useMemo } from "react";

const GradientBar = ({ label, value, index, barWidth }) => {

  
  const gradientColors = {
    0: {
      from: "#1e74bb", // Bright blue
      to: "#1C76BD4D"    // Light blue
    },
    1: {
      from: "#47a9c3", // Green
      to: "#41A2C34D"    // Light green
    },
    2: {
      from: "#65cbc8", // Purple
      to: "#69D2C94D"    // Light purple
    },
    3: {
      from: "#ea580c", // Orange
      to: "#ffedd5"    // Light orange
    },
    4: {
      from: "#4338ca", // Indigo
      to: "#e0e7ff"    // Light indigo
    }
  }
  
  let percentageValue =  value ? (parseInt(value).toFixed(1)  || 0) : 0
  
  return (
    <div className={`mb-6 relative ${barWidth} text-center overflow-hidden max-w-[18rem]`}>
      <div className="h-[85%] relative">
        <AnimatedDiv
          className="absolute bottom-0 rounded-lg !w-full"
          style={{
            height: `${(value )}%`,
            background: `linear-gradient(to bottom, ${gradientColors[index]?.from || "#0ea5e9"}, ${gradientColors[index]?.to || "#e0f2fe"})`,
          }}
          height={`${(value)}%`}
          duration={1}
          delay={index * 0.2}
        />
      </div>
      <div className="flex flex-col gap-1 py-3 overflow-hidden">
        <span className={`z-10 text-black`}>{percentageValue}%</span>
        <span className={`font-medium text-black z-10`}>
          {label}
          {/* {(percentageValue >= 90) && <span className="rounded-full ml-2">
            <Icon  name="check circle" color="green" size='large' />
          </span> } */}
          </span>
      </div>
    </div>
  )
};

const StarRating = ({ count = 0 }) => {
  const getStarType = (index) => {
    if (count >= index) return "full";
    if (count > index - 1) return "half";
    return "empty";
  };

  const renderStar = (type) => {
    switch (type) {
      case "full":
        return (
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
        );
      case "half":
        return <path d="M12 17.8 5.8 21 7 14.1 2 9.3l7-1L12 2"></path>;
      default:
        return <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>;
    }
  };

  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((num) => (
        <svg
          key={`rating-star-${num}`}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`h-4 w-4 ${getStarType(num) === "empty" ? "text-gray-300" : "fill-yellow-400 text-yellow-400"}`}
        >
          {renderStar(getStarType(num))}
        </svg>
      ))}
    </div>
  );
};

const ProbabilitySection = ({ }) => {
  const { contextData: data = {}, activeTab } = useSelector((state) => state.studentPerformenceConstruct);
  const { FETCH_CONSTRUCT_DATA: isLoading = false, UPDATE_PREDICTION_dATA: isUpdateLoader = false } = useSelector((state) => state?.loader)

  const colorClass = getColorClass(activeTab);
  const probability = data?.construct_label || []

  const sortedProbability = useMemo(() => {
      if (!probability || probability.length === 0) return [];
      
      const sortedData = [...probability];
      
      const order = ["LowOptimism", "MediumOptimism", "HighOptimism"];
      
      return sortedData.sort((a, b) => {
        return order.indexOf(a.label) - order.indexOf(b.label);
      });
  }, [probability])

  return (
    <div className="grid grid-cols-1 gap-4">
      <Card className={`card border-${colorClass}-200 bg-${colorClass}-50`}>
        <CardHeader className='flex !flex-row items-center justify-between relative'>
          <CardTitle className={`card-title text667-${colorClass}-900 text-[#3e9dc1]`}>Probability of Construct Label</CardTitle>
          <InfoMark
            message="The chart shows the probability of an individual belonging to each of
            the three persistence categories. These probabilities are calculated
            independently, meaning they don't add up to 100%. Instead, each bar
            represents how likely someone is to fall into that specific category
            based on their behaviors."
          />
        </CardHeader>
        <CardContent className={`text-${colorClass}-700`}>
          <div className="space-y-4">
            <div className="space-y-3 relative">
              <div className="flex h-[30rem] gap-6 ">
                {isLoading ? (
                  [...Array(4)].map((_, index) => (
                    <div key={index} className="mb-6 last:mb-0 h-full w-1/4 flex flex-col gap-2">
                      <div className="h-[85%] relative bg-gray-300 animate-pulse !scale-x-100">
                      </div>
                      <div className="h-[10%] bg-gray-200 animate-pulse !scale-x-100" style={{ transition: 'width 1s ease-in-out' }}></div>
                    </div>
                  ))
                )
                  :
                  probability?.length ?
                    sortedProbability.map(({ label, percentage = 0, value, behavior_graph_key, construct_id }, index, array) => (
                      <GradientBar key={label} label={label} value={(+percentage)?.toFixed(20) || +value} color={colorClass} index={index} barWidth={`w-1/${probability?.length}`} />
                    ))
                    : <div className="flex items-center justify-center min-h-[35rem] mx-auto text-black">
                      <span>Oops! It looks like we don't have any Probability data to show here right now.</span>
                    </div>
                }
              </div>
              {
                isUpdateLoader && (
                  <div className="flex items-center justify-center min-h-[25rem] w-full text-black absolute bg-transparent top-0">
                    <Loader />
                  </div>
                )
              }
            </div>
            {/* <div className="flex items-center gap-2 rounded-lg bg-white p-2">
              <span className="text-sm font-medium">Interest:</span>
              <StarRating count={data?.interest_rating_five_scale || 0} />
            </div> */}
          </div>
        </CardContent>
      </Card>

    </div>
  )
}

export default ProbabilitySection


